import { FC, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export type EventAboutProps = {
  description: string;
  maxLengthInShort: number;
};

const MarkdownWrapper: FC<{
  children: string;
}> = (props) => {
  const { children } = props;

  return <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>;
};

const EventAbout = (props: EventAboutProps) => {
  const { description, maxLengthInShort } = props;
  const [readMore, setReadMore] = useState(false);

  if (description.length == 0) {
    return null;
  }

  if (description.length < maxLengthInShort || readMore) {
    return (
      <div className="prose prose-invert max-w-none">
        <MarkdownWrapper>{description}</MarkdownWrapper>
      </div>
    );
  }

  return (
    <div>
      <div className="prose prose-invert max-w-none">
        <MarkdownWrapper>
          {`${description.slice(0, maxLengthInShort)}...`}
        </MarkdownWrapper>
      </div>
      <button onClick={() => setReadMore(true)}>
        <p className={`text-h5 font-bold text-gray-300`}>Read more..</p>
      </button>
    </div>
  );
};

export default EventAbout;
